import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditExpenseTypeComponent } from '@app/core/windows'; 


@Component({
  selector: 'expenses-types-crud',
  templateUrl: './expenses-types-crud.component.html',
  providers: [ DatasourceService ]
})
export class ExpensesTypesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditExpenseTypeComponent, {static: false}) window !: CreateEditExpenseTypeComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Tipo de Gasto';

  protected name: string = 'Tipos de Gastos';

  protected table: string = 'expenses_types';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}